export const API_URL='https://jfmy8u72m4.execute-api.us-east-1.amazonaws.com/dev/myapis';
export const ENV = 'dev';